import { useShouldStartOutageBanner } from '@ms/yammer-hooks/dist/outageBanner';
import React, { ReactNode, Suspense } from 'react';

import LoadableOutageBanner from './LoadableOutageBanner';

type UseOutageBanner = () => ReactNode;
export const useOutageBanner: UseOutageBanner = () => {
  const shouldShowOutageBanner = useShouldStartOutageBanner();
  const officeStatusPageUrl = 'https://go.microsoft.com/fwlink/?linkid=2195690';

  const banner = (
    <Suspense fallback={null}>
      <LoadableOutageBanner statusPageUrl={officeStatusPageUrl} />
    </Suspense>
  );

  return shouldShowOutageBanner ? banner : null;
};
